import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";
import { Link } from 'react-router-dom';

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function Brands({ }) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { categoryId } = useParams();

    const Box = ({ id, picture, title }) => {
        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/brand/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }
        return (
            <Link className='bsh-4 bc-w ta-c mb-4 br-4 o-h' style={{ flex: '0 0 calc(50% - .8rem)' }} to={`/brand/${id}/${categoryId}`}>
                <Img />
                <div className='p-3' style={{ color: '#757575', fontSize: '1.2rem' }}>
                    {title}
                </div>
            </Link>
        );
    }

    useEffect(() => {
        setPageTitle('شرکت های همراه ما');

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/brand/getlist?categoryId=${categoryId}`), { signal });
                const json = await response.json();
                setData(json.data);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='d-f fw-w jc-sb p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '6rem' }}>
            {data.map(x => {
                return (
                    <Box
                        key={x.id}
                        id={x.id}
                        picture={x.picture}
                        title={x.title}
                    />
                )
            })}
        </div>
    );
}